import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IMapLoadIconProps {
  stroke?: string;
}
export const MapLoadIcon = React.memo(({ stroke = '#6B7280', ...rest }: IMapLoadIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...rest}>
    <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" clipPath="url(#clip0_7171_65726)">
      <path d="M13.333 16.667a6.667 6.667 0 1013.334 0 6.667 6.667 0 00-13.334 0zM11.25 26.667A13.358 13.358 0 1026.667 5M20 30v6.667M13.333 36.666h13.334"></path>
    </g>
    <defs>
      <clipPath id="clip0_7171_65726">
        <path fill="#fff" d="M0 0H40V40H0z"></path>
      </clipPath>
    </defs>
  </svg>
));
export default MapLoadIcon;
